import { useState } from "react";
import { ArrowLeftRight } from "lucide-react";
import { Label } from "./ui-bits";
import { UNIT_CONVERSIONS, convertUnit, round } from "@/data/tools";

function ConverterRow({ c }) {
  const [left, setLeft] = useState("");
  const [right, setRight] = useState("");

  const onLeft = (v) => {
    setLeft(v);
    const out = convertUnit(v, c.factor);
    setRight(out === null ? "" : String(round(out, 2)));
  };
  const onRight = (v) => {
    setRight(v);
    const out = convertUnit(v, c.factor, true);
    setLeft(out === null ? "" : String(round(out, 2)));
  };

  return (
    <div className="card-line rounded-2xl p-6 sm:p-7" data-testid={`unit-row-${c.id}`}>
      <div className="flex flex-wrap items-baseline justify-between gap-3">
        <h3 className="font-display text-2xl tracking-wide">{c.name}</h3>
        <p className="mono-label text-dusk">1 {c.from} = {round(c.factor, 4)} {c.to}</p>
      </div>
      <div className="grid sm:grid-cols-[1fr,auto,1fr] gap-3 items-center mt-5">
        <label className="block">
          <span className="mono-label text-dusk block mb-2">{c.from}</span>
          <input type="number" inputMode="decimal" className="field" value={left} onChange={(e) => onLeft(e.target.value)} placeholder="0" data-testid={`unit-input-${c.id}-from`} />
        </label>
        <ArrowLeftRight size={18} className="text-teal mx-auto hidden sm:block" aria-hidden="true" />
        <label className="block">
          <span className="mono-label text-dusk block mb-2">{c.to}</span>
          <input type="number" inputMode="decimal" className="field" value={right} onChange={(e) => onRight(e.target.value)} placeholder="0" data-testid={`unit-input-${c.id}-to`} />
        </label>
      </div>
      <p className="text-xs text-bone/70 mt-4"><span className="text-teal">UK context:</span> {c.ukRange}</p>
      <p className="text-xs text-dusk mt-1.5 leading-relaxed">{c.note}</p>
    </div>
  );
}

export default function UnitConverter() {
  return (
    <div data-testid="unit-converter">
      <Label>Type in either box — the other updates</Label>
      <div className="grid md:grid-cols-2 gap-5 mt-6">
        {UNIT_CONVERSIONS.map((c) => (
          <ConverterRow key={c.id} c={c} />
        ))}
      </div>
      <p className="text-xs text-dusk leading-relaxed mt-6 max-w-3xl">
        Conversion factors are derived from molecular mass and WHO reference standards and are rounded
        for display. Reference intervals differ between laboratories and assays — always read a result
        against the range printed on your own report, with your clinician.
      </p>
    </div>
  );
}
